import React, { useContext, useState, useEffect } from "react";
import { singleProductContent, foodboomButton, foodboomNavigation } from "./style.mod.scss";
import ProductContext from "services/product-context";
import { trackViewItem, trackViewedProductKlaviyo } from "helpers/analytics";
import EnhancedPDPLayout from "./enhanced-layout";
import DefaultPdpLayout from "./default-layout";
import GlobalContext from "services/global-context";
import { fetchCart, addCartItemsWithCustomAttribute, addDiscount } from "data/cart";
import { trackAddedToCartKlaviyo } from "helpers/analytics";

const PdpLayout = ({ reviewSummary, settings, product }) => {
  const productContext = useContext(ProductContext);
  const { toggleCart, cartOpened } = useContext(GlobalContext);

  if (!productContext) return <></>;

  const { handle, variants, currentVariant: selectedVariant, content: content } = productContext;
  const [currentVariant, setCurrentVariant] = useState(selectedVariant || variants[0]);
  const pdpLayout = product?.content?.layout;
  const [showFoodboomLinks, setShowFoodboomLinks] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setShowFoodboomLinks(true);
    }
  }, []);


  useEffect(() => {

    if (window.location.search.includes("variant=")) {
      let savedParams = window.location.search;
      let queryParam = "gid://shopify/ProductVariant/" + window.location.search.match(/variant=([0-9A-Za-z]*)/)[1];
      let matchingVariant = variants?.filter(a => btoa(queryParam) === a.id)[0];

      setCurrentVariant(matchingVariant);

      window.history.pushState("", "", `/products/${handle}/${matchingVariant.handle.current}${savedParams}`);
    }
  }, []);

  useEffect(() => {
    trackViewItem({ product: currentVariant });
    trackViewedProductKlaviyo(productContext);
  }, []);

  const checkAndAddProductToCart = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const productIdFromUrl = params.get("addToCart");
      const discountFromUrl = params.get("discount");

      if (!productIdFromUrl || !discountFromUrl) return;

      const strippedProductId = currentVariant?._id?.split("-")[1];
      if (strippedProductId !== productIdFromUrl) return;

      await addCartItemsWithCustomAttribute([currentVariant?.id], "Email Discount", discountFromUrl);
      await addDiscount(discountFromUrl);

      const cart = await fetchCart();
      trackAddedToCartKlaviyo(cart, currentVariant);

      if (!cartOpened) toggleCart();

    } catch (error) {
      console.error("Error adding product to cart:", error);
    }
  };

  useEffect(() => {
    checkAndAddProductToCart();
  }, [currentVariant]);

  return (
    <div className={singleProductContent} style={{ backgroundColor: content?.bgColor && content?.bgColor?.hex }}>
      <div className={foodboomNavigation}>
        {showFoodboomLinks && window.location.href.includes("foodboom") && (
          <a className={foodboomButton} href="/foodboom">Zur FOODBOOM-Übersicht</a>
        )}
        {showFoodboomLinks && window.location.href.includes("der-aluminium-topf") && (
          <a className={foodboomButton} href="/products/foodboom-die-aluminium-pfanne-creme/24cm-creme">Zur FOODBOOM-Pfanne</a>
        )}
        {showFoodboomLinks && window.location.href.includes("die-aluminium-pfanne") && (
          <a className={foodboomButton} href="/products/foodboom-der-aluminium-topf-schwarz/saucier">Zum FOODBOOM-Topf</a>
        )}
      </div>

      {pdpLayout === "enhanced" ?
        <EnhancedPDPLayout reviewSummary={reviewSummary} settings={settings} product={product} currentVariant={currentVariant} /> :
        <DefaultPdpLayout reviewSummary={reviewSummary} settings={settings} product={product} currentVariant={currentVariant} />}
    </div>
  );
};

export default PdpLayout;

